export default function CoinIcon({ size = 16, ...props }) {
	return <img src="/assets/icons/ufcoin.svg" alt="UFC Coin" style={{ width: size, height: size }} {...props} />;
}
